import React from 'react';
import { Box, Typography } from '@drone-js/core';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';
import { getImageUrl } from 'core/utils/activityUrlGenerator';
import { ActivitiesOverlayTextSearchNoResultSeenEventActivitiesFieldsV4 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesOverlayTextSearchNoResultSeenEventActivitiesManifestV4 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import TextSearchGlobalKeywordNoResults from 'component/common/TextSearch/TextSearchResult/TextSearchNoResults/TextSearchGlobalKeywordNoResults';

const TextSearchNoResults: React.FC<{ searchText: string; cms: CmsValue; isGlobalKeywordSearch: boolean }> = (props) => {
    const { searchText, cms, isGlobalKeywordSearch } = props;

    React.useEffect(() => {
        trackElementEvent<ActivitiesOverlayTextSearchNoResultSeenEventActivitiesFieldsV4>(ActivitiesOverlayTextSearchNoResultSeenEventActivitiesManifestV4.ids, {
            search_phrase: searchText,
        });
    }, [searchText]);

    // Workaround for decimal flex value
    const flexGrow = { style: { flexGrow: 0.75 } };

    if (isGlobalKeywordSearch) {
        return <TextSearchGlobalKeywordNoResults searchText={searchText} cms={cms} />;
    }

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            data-testid="activities-overlay-text-search-no-result"
            data-element-name="activities-overlay-text-search-no-result"
            flexShrink={1}
            flexBasis={0}
            {...flexGrow}
        >
            <ActivityImage alt={cms[277312]} src={getImageUrl('search-deal-2.svg')} loading="immediate" width="140px" responsive="manual" />
            <Typography variant="heading-default">{cms[127082]}</Typography>
            <Typography variant="body-s" mt="8">
                {cms[127083]}
            </Typography>
        </Box>
    );
};
TextSearchNoResults.displayName = 'TextSearchNoResults';

export default TextSearchNoResults;
